// src/features/commission/CommissionPage.tsx
import { GlassCard } from '../../app/components/ui/GlassCard';
import { EmptyState } from '../../app/components/foundation';

/**
 * No commission endpoint has been provided for the representative
 * panel yet, so the sample totals/recent-commissions data have been
 * removed rather than kept as a stand-in. Renders an explicit
 * EmptyState instead of fabricated commission figures — swap this for
 * real CommissionSummary/CommissionList wiring once a commission API
 * is confirmed.
 */
export function CommissionPage() {
  return (
    <div className="flex flex-col gap-4 sm:gap-5">
      <div className="flex flex-col gap-1">
        <h1 className="text-lg font-semibold text-[var(--vania-colors-text-primary,#f5f6fa)]">
          کمیسیون
        </h1>
        <p className="text-sm text-[var(--vania-colors-text-secondary,#a3aab8)]">
          خلاصه کمیسیون و تسویه‌های شما.
        </p>
      </div>

      <GlassCard>
        <EmptyState message="اتصال کمیسیون نماینده به Backend هنوز فراهم نشده است؛ این بخش پس از آماده شدن API در دسترس خواهد بود." />
      </GlassCard>
    </div>
  );
}
